import { MappableModel } from '@se-po/shared-data-access-models'

export class ClientApproval extends MappableModel {
  public id: number
  public user_id: number
  public client_id: number
  public approved: boolean
}
